// frontend/src/services/apiClient.js
// Client HTTP pour communiquer avec l'API backend

import axios from 'axios';

const API_BASE_URL = 'https://api-nova.digitalprojects.fr/backend/public/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour les réponses d'erreur
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;
